import React, { useEffect, useState, useRef } from "react";
import { db } from "./firebase";
import {
  collection,
  doc,
  setDoc,
  updateDoc,
  getDoc,
  onSnapshot,
  serverTimestamp
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useParams, useNavigate } from "react-router-dom";
import "./MillionaireGame.css"; // ✅ Reuse existing CSS

const MillionaireLiveHost = () => {
  const { assignmentId } = useParams();
  const [gameId, setGameId] = useState("");
  const [players, setPlayers] = useState([]);
  const welcomeAudioRef = useRef(null);
  const navigate = useNavigate();
  const auth = getAuth();
  const hostUID = auth.currentUser?.uid;
  const [volume, setVolume] = useState(0.2); // default to 20%
  const [isRevealed, setIsRevealed] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);

  const generatePIN = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let pin = "";
    for (let i = 0; i < 6; i++) {
      pin += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return pin;
  };

  useEffect(() => {
    const createGame = async () => {
      if (!assignmentId || !hostUID) return;

      try {
        const pin = generatePIN();
        const gameRef = doc(db, "liveGames", pin);

        await setDoc(gameRef, {
          assignmentId,
          hostUID,
          currentQuestionIndex: 0,
          isActive: true,
          createdAt: serverTimestamp(),
          players: {},
          selectedQuestions: []
        });

        setGameId(pin);

        // Load assignment and fetch questions
        const assignmentSnap = await getDoc(doc(db, "assignments", assignmentId));
        const questionIds = assignmentSnap.data()?.questions || [];

        const questionDocs = await Promise.all(
          questionIds.map((qid) => getDoc(doc(db, "questions", qid)))
        );

        const allQuestions = questionDocs.map((docSnap) => {
            const q = docSnap.data();
            if (!q) return null;
          
            const correct = q.answers?.[0] || q.answer || "";
            const options = Array.isArray(q.choices) && typeof q.choices[0] === "object"
              ? q.choices
              : (q.choices || []).map((text) => ({ text, isCorrect: text === correct }));
          
            return {
              questionId: docSnap.id,
              questionText: q.questionText || "",           // ✅ FIXED: store under correct key
              optionalQuestionText: q.optionalQuestionText || "",
              questionLatex: q.questionLatex || "",
              correctAnswer: correct,
              options,
              difficulty: parseInt(q.difficulty || "1", 10),
              paragraphs: q.questionParagraphs || []
            };
          }).filter(Boolean);
          

        const sorted = allQuestions.sort((a, b) => a.difficulty - b.difficulty);
        const total = sorted.length;
        const selected = [];

        for (let i = 0; i < 15; i++) {
          const start = Math.floor((i / 15) * total);
          const end = Math.floor(((i + 1) / 15) * total);
          const bucket = sorted.slice(start, end);
          if (bucket.length > 0) {
            const random = bucket[Math.floor(Math.random() * bucket.length)];
            selected.push(random);
          }
        }

        await updateDoc(gameRef, {
          selectedQuestions: selected
        });

        const unsub = onSnapshot(gameRef, (snap) => {
          const data = snap.data();
          if (data?.players) {
            setPlayers(Object.values(data.players));
          }
        });

        return () => unsub();
      } catch (err) {
        console.error("❌ Error creating live game:", err);
      }
    };

    createGame();
  }, [assignmentId, hostUID]);

  useEffect(() => {
    if (welcomeAudioRef.current) {
      welcomeAudioRef.current.volume = volume;
    }
  }, [volume]);

  const handleStartGame = async () => {
    if (!gameId) return;

    if (welcomeAudioRef.current) {
      welcomeAudioRef.current.pause();
    }

    await updateDoc(doc(db, "liveGames", gameId), {
      currentQuestionIndex: 1
    });

    navigate(`/millionaire-live-game/${gameId}?host=true`);
  };

  return (
    <div className="welcome-screen">
      <audio
        ref={welcomeAudioRef}
        src="/Millionaire/Who_Wants_To_Be_A_Millionaire_Theme.mp3"
        autoPlay
        loop
      />

      <img
        src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FBitmoji_wave.png?alt=media&token=68db9705-382e-4ae2-b718-f5808de26268"
        alt="Bitmoji"
        className="bitmoji"
      />

      <div className="logo-wrapper">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FMillionaire%20Logo.png?alt=media&token=64690774-c189-4a45-8b88-4eabf0ed0a55"
          alt="Millionaire Logo"
          className="millionaire-logo"
        />
      </div>

      <h2
        style={{
          marginTop: "-0.5rem",
          fontSize: "2.5rem",
          letterSpacing: "0.2rem",
          color: "#ffeaa7",
          fontWeight: "bold",
          textShadow: "0 0 8px rgba(0,0,0,0.3)"
        }}
      >
        GAME PIN: <span style={{ fontWeight: "900" }}>{gameId}</span>
      </h2>
      <div style={{ marginTop: "1.5rem", textAlign: "center" }}>
  <p style={{ color: "#fff", marginBottom: "0.5rem", fontWeight: "bold" }}>
    📱 Scan to Join:
  </p>
  <img
  src="/assets/QR Code Millionaire Join.png"
  alt="Join Game QR Code"
  onClick={() => setShowQRModal(true)}
  style={{
    width: "150px",
    height: "150px",
    borderRadius: "8px",
    boxShadow: "0 0 8px rgba(255,255,255,0.2)",
    cursor: "pointer",
    transition: "transform 0.2s",
  }}
/>

</div>
{showQRModal && (
  <div
    onClick={() => setShowQRModal(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
      cursor: "pointer",
    }}
  >
    <img
      src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FQR%20Code%20Millionaire%20Join.png?alt=media&token=f2ea9029-ff6e-423f-b2e3-96aa771d368c"
      alt="Enlarged QR"
      style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: "12px", boxShadow: "0 0 20px rgba(255,255,255,0.4)" }}
    />
  </div>
)}


      <div style={{ marginTop: "1.5rem", marginBottom: "1rem", textAlign: "center" }}>
        <label style={{ color: "#fff", fontWeight: "bold", marginRight: "1rem" }}>
          🎵 Volume:
        </label>
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={(e) => setVolume(parseFloat(e.target.value))}
          style={{ width: "200px" }}
        />
      </div>

      <div
        style={{
          marginTop: "1.5rem",
          color: "#fff",
          background: "rgba(255,255,255,0.05)",
          padding: "1rem 2rem",
          borderRadius: "12px",
          boxShadow: "0 0 15px rgba(0,0,0,0.2)",
          minWidth: "300px"
        }}
      >
        <h3>Players Joined:</h3>
        {players.length === 0 ? (
          <p>Waiting for players...</p>
        ) : (
            <ul
            style={{
              listStyle: "none",
              padding: 0,
              marginTop: "1rem",
              display: "flex",
              flexWrap: "wrap",
              gap: "0.75rem",
              justifyContent: "center"
            }}
          >
          
            {players.map((p, i) => (
              <li
                key={i}
                style={{
                    background: "#1c3a6b",
                    color: "#fff",
                    padding: "0.6rem 1rem",
                    borderRadius: "10px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    textAlign: "center",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                    whiteSpace: "nowrap"
                  }}
                  
              >
                {p.name}
              </li>
            ))}
          </ul>
        )}
      </div>

      <button className="start-btn" onClick={handleStartGame}>
        Start Game
      </button>
    </div>
  );
};

export default MillionaireLiveHost;
